import {createFocusManager, FocusableProvider, renderReact, VerticalList} from 'focus-manager/web';

import Rail from './Components/Rail';
import rails from './Data/rails';

const focusManager = createFocusManager({
    useNativeFocus: true,
    preventScroll: true,
    throttleDurationMs: 300,
});

window.addEventListener('keydown', e => {
    // eslint-disable-next-line deprecation/deprecation
    switch (e.keyCode) {
        case 27:
            focusManager.blur();

            break;
        case 32:
            focusManager.select();

            break;
        case 37:
            focusManager.left();

            break;
        case 38:
            focusManager.up();

            break;
        case 39:
            focusManager.right();

            break;
        case 40:
            e.preventDefault();

            focusManager.down();

            break;
    }
});

renderReact(
    <FocusableProvider focusManager={focusManager}>
        <VerticalList className="rails">
            {rails.map(rail => (
                <Rail {...rail} key={rail.id} />
            ))}
        </VerticalList>
    </FocusableProvider>,
    document.querySelector('#root')!
);

window.focusManager = focusManager;
